import { decodeHexResponse } from '../_common/common.utils';
import DashboardTypes from './dashboard.types';

const INITIAL_STATE = {
	dashboardData: null,
	dashboardEnhancedData: null,
	employeeListEnhancedData: null,
};

const dashboardReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		case DashboardTypes.DASHBOARD_START:
			return { ...state, dashboardData: null };
		case DashboardTypes.DASHBOARD_SUCCESS:
			return {
				...state,
				dashboardData: decodeHexResponse(action.payload, 'fetchSectionWiseDataKey'),
			};
		case DashboardTypes.DASHBOARD_FAILURE:
			return {
				...state,
				dashboardData: decodeHexResponse(action.payload, 'fetchSectionWiseDataKey'),
			};
		case DashboardTypes.DASHBOARD_RESPONSE_CHANGED:
			return { ...state, dashboardData: null };
		case DashboardTypes.DASHBOARD_RESPONSE_REST_START:
			return { ...state, dashboardData: null };
		// Enhanced Dashboard Cases
		case DashboardTypes.DASHBOARD_ENHANCED_START:
			return { ...state, dashboardEnhancedData: null };
		case DashboardTypes.DASHBOARD_ENHANCED_SUCCESS:
			return {
				...state,
				dashboardEnhancedData: decodeHexResponse(
					action.payload,
					'fetchDashboardEnhancedKey',
				),
			};
		case DashboardTypes.DASHBOARD_ENHANCED_FAILURE:
			return {
				...state,
				dashboardEnhancedData: decodeHexResponse(
					action.payload,
					'fetchDashboardEnhancedKey',
				),
			};
		case DashboardTypes.DASHBOARD_ENHANCED_RESPONSE_CHANGED:
			return { ...state, dashboardEnhancedData: null };
		case DashboardTypes.DASHBOARD_ENHANCED_RESPONSE_REST_START:
			return { ...state, dashboardEnhancedData: null };
		// Enhanced Employee List Cases
		case DashboardTypes.EMPLOYEE_LIST_ENHANCED_START:
			return { ...state, employeeListEnhancedData: null };
		case DashboardTypes.EMPLOYEE_LIST_ENHANCED_SUCCESS:
			return {
				...state,
				employeeListEnhancedData: decodeHexResponse(
					action.payload,
					'fetchEmployeeListEnhancedKey',
				),
			};
		case DashboardTypes.EMPLOYEE_LIST_ENHANCED_FAILURE:
			return {
				...state,
				employeeListEnhancedData: decodeHexResponse(
					action.payload,
					'fetchEmployeeListEnhancedKey',
				),
			};
		case DashboardTypes.EMPLOYEE_LIST_ENHANCED_RESPONSE_CHANGED:
			return { ...state, employeeListEnhancedData: null };
		case DashboardTypes.EMPLOYEE_LIST_ENHANCED_RESPONSE_REST_START:
			return { ...state, employeeListEnhancedData: null };
		default:
			return state;
	}
};

export default dashboardReducer;
